import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionCancelReason } from '../../enums';
import { SubscriptionCancelReasonPipe } from '../../pipes';

@Component({
  selector: 'app-subscription-cancel-reason',
  imports: [CommonModule, SubscriptionCancelReasonPipe],
  templateUrl: './subscription-cancel-reason.component.html',
  styleUrl: './subscription-cancel-reason.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionCancelReasonComponent {
  public readonly reason = input.required<SubscriptionCancelReason>();
}
